import { Association } from '@prisma/client';

import { routes } from '@/shared/routes';
import { appendQuery, offcanvasBackUrl } from '@/shared/utils/url';

import { insertLinkedIndividualRow } from '@/front/actions/associations';
import { modelId } from '@/front/actions/utils';
import {
  CompaniesHousePersonDetails,
  CompaniesHousePersonMatch,
  openCompaniesHousePersonModal,
} from '@/front/companiesHousePersonModal';
import { GET, POST } from '@/front/fetch';

const newIndividualUrl = (organisationId: string, person: CompaniesHousePersonDetails) =>
  appendQuery(offcanvasBackUrl(routes.individuals.create(), 'contacts'), {
    givenName: person.givenName || undefined,
    surname: person.surname || undefined,
    organisationId,
  });

export const createAndLinkCompaniesHousePerson = async (button: HTMLAnchorElement | HTMLButtonElement) => {
  const organisationId = modelId();
  const recordId = button.dataset.value;

  if (!organisationId || !recordId) return;

  const res = await GET(
    appendQuery(routes.organisations.companiesHousePersonMatches({ id: organisationId }), { recordId }),
  );

  if (!res.ok) return;

  const { person, matches } = (await res.json()) as {
    person: CompaniesHousePersonDetails;
    matches: CompaniesHousePersonMatch[];
  };

  if (!matches.length) {
    window.location.href = newIndividualUrl(organisationId, person);
    return;
  }

  const choice = await openCompaniesHousePersonModal(person, matches);

  if (!choice) return;

  if (choice.action === 'create') {
    window.location.href = newIndividualUrl(organisationId, person);
    return;
  }

  const association: Partial<Association> = {
    organisationId,
    individualId: choice.individualId,
  };

  const linkRes = await POST(`${routes.associations.create()}?view=Organisation`, association);

  if (linkRes.ok) {
    insertLinkedIndividualRow(await linkRes.text());
  }
};
